import { render, staticRenderFns } from "./r-product-dialog.vue?vue&type=template&id=88869848&scoped=true"
import script from "./r-product-dialog.vue?vue&type=script&lang=js"
export * from "./r-product-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-product-dialog.vue?vue&type=style&index=0&id=88869848&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88869848",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88869848')) {
      api.createRecord('88869848', component.options)
    } else {
      api.reload('88869848', component.options)
    }
    module.hot.accept("./r-product-dialog.vue?vue&type=template&id=88869848&scoped=true", function () {
      api.rerender('88869848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/product/r-product-dialog.vue"
export default component.exports